'use strict';

var util = require('../../../util/property-util');

module.exports = {
    getGroupId: function (trainMappings, projectId, trainId) {
        var foundGroupId = undefined;
        trainMappings.some(function (mapping) {
            if (mapping.projectId == projectId && mapping.trainId == trainId) {
                foundGroupId = mapping.groupId;
            }
        });
        return foundGroupId;
    },

    getTrainId: function (trainMappings, projectId, groupId) {
        var foundTrainId = undefined;
        trainMappings.some(function (mapping) {
            if (mapping.projectId == projectId && mapping.groupId == groupId) {
                foundTrainId = mapping.trainId;
            }
        });
        return foundTrainId;
    },

    getArrayFilteredOn: function (data, discriminator, value) {
        var returnArray = [];

        data.forEach(function (entry) {
            if (entry[discriminator] == value) {
                returnArray.push(entry);
            }
        });
        return returnArray;
    },

    getHighestPriorityObject: function (data, discriminator, value) {
        var maxPriority = 0;
        var foundEntry = undefined;

        data.forEach(function (entry) {
            if (entry[discriminator] == value && entry.priority > maxPriority) {
                maxPriority = entry.priority;
                foundEntry = entry;
            }
        });
        return foundEntry;
    },

    getHighestPriority: function (data, discriminator, value) {
        var maxPriority = 0;

        data.forEach(function (entry) {
            if (entry[discriminator] == value && entry.priority > maxPriority) {
                maxPriority = entry.priority;
            }
        });
        return maxPriority;
    },

    getTrainObject: function (groupId, trainData) {
        var foundTrain = undefined;
        trainData.some(function (train) {
            if (train.groupId == groupId) {
                foundTrain = train;
                return true;
            }
        });
        return foundTrain;
    },

    getRequest: function (type, token, object) {
        if (!util.isDefined(object)) {
            object = {};
        }
        var request = {
            'auth': {
                "jsonrpc": "2.0",
                "method": "user.login",
                "params": {
                    "user": object.user,
                    "password": object.password
                },
                "id": new Date().getTime(),
                "auth": null
            },
            'issues': {
                "jsonrpc": "2.0",
                "method": "trigger.get",
                "params": {
                    "groupids": object.groupIds,
                    "monitored": true,
                    "active": true,
                    "maintenance": false,
                    "expandData": 0,
                    "expandComment": 0,
                    "expandDescription": 0,
                    "expandExpression": 0,
                    "output": "extend",
                    "sortfield": [
                        "lastchange",
                        "priority"
                    ],
                    "sortorder": "DESC",
                    "selectLastEvent": [
                        "eventid",
                        "acknowledged",
                        "clock",
                        "ns",
                        "object",
                        "objectid",
                        "source",
                        "value",
                        "value_changed"
                    ],
                    "selectHosts": [
                        "hostid",
                        "name"
                    ],
                    "filter": {
                        "value": 1
                    }
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'hosts': {
                "jsonrpc": "2.0",
                "method": "host.get",
                "params": {
                    "output": "extend",
                    "groupids": object.groupId
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'hostgroups': {
                "jsonrpc": "2.0",
                "method": "hostgroup.get",
                "params": {
                    "monitored": true,
                    "active": true,
                    "maintenance": false,
                    "output": "extend",
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'hostgroup.get': {
                "jsonrpc": "2.0",
                "method": "hostgroup.get",
                "params": {
                    "groupids": object,
                    "output": "extend"
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'hostgroup.delete': {
                "jsonrpc": "2.0",
                "method": "hostgroup.delete",
                "params": object,
                "id": new Date().getTime(),
                "auth": token
            },
            'host.get': {
                "jsonrpc": "2.0",
                "method": "host.get",
                "params": {
                    "groupids": object,
                    "output": "extend"
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'host.delete': {
                "jsonrpc": "2.0",
                "method": "host.delete",
                "params": object,
                "id": new Date().getTime(),
                "auth": token
            },
            'event': {
                "jsonrpc": "2.0",
                "method": "event.get",
                "params": {
                    "output": "extend",
                    "select_acknowledges": "extend",
                    "eventids": object.eventId,
                    "hostids": object.hostId,
                    "sortfield": ["clock", "eventid"],
                    "sortorder": "DESC"
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'acknowledge': {
                "jsonrpc": "2.0",
                "method": "event.acknowledge",
                "params": {
                    "eventids": object.eventId,
                    "userid": object.userId,
                    "message": object.message
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'users': {
                "jsonrpc": "2.0",
                "method": "user.get",
                "params": {
                    "output": "extend",
                    "status": 0
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'proxy.create': {
                "jsonrpc": "2.0",
                "method": "proxy.create",
                "params": {
                    "host": object.host,
                    "status": object.status || "5"
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'proxy.delete': {
                "jsonrpc": "2.0",
                "method": "proxy.delete",
                "params": object,
                "id": new Date().getTime(),
                "auth": token
            },
            'host.create': {
                "jsonrpc": "2.0",
                "method": "host.create",
                "params": {
                    "host": object.host,
                    "proxy_hostid": object.proxyHostId,
                    "groups": object.groups,
                    "templates": object.templates,
                    "interfaces": object.interfaces,
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'hostgroup.create': {
                "jsonrpc": "2.0",
                "method": "hostgroup.create",
                "params": {
                    "name": object.name,
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'monitorProxy': {
                "jsonrpc": "2.0",
                "method": "item.create",
                "params": {
                    "name": object.name,
                    "key_": object.key,
                    "hostid": "10114",
                    "units": "unixtime",
                    "type": 5,
                    "value_type": 3,
                    "applications": [
                        "510"
                    ],
                    "delay": 10
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'monitorProxyTrigger': {
                "jsonrpc": "2.0",
                "method": "trigger.create",
                "params": {
                    "description": object.name,
                    "expression": object.expression,
                    "host": "10114",
                    "priority": 5
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'comment': {
                "jsonrpc": "2.0",
                "method": "trigger.update",
                "params": {
                    "triggerid": object.triggerId,
                    "comments": object.comment
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'item.get': {
                "jsonrpc": "2.0",
                "method": "item.get",
                "params": {
                    "hostids": object,
                    "output": "extend"
                },
                "id": new Date().getTime(),
                "auth": token
            },
            'item.delete': {
                "jsonrpc": "2.0",
                "method": "item.delete",
                "params": object,
                "id": new Date().getTime(),
                "auth": token
            }
        };
        return request[type];
    },

    getConfig: function () {
        var config = {};
        config.method = 'POST';
        config.headers = {'Content-Type': 'application/json-rpc'};
        return config;
    },

    getGroupIds: function (trainMappings, projectId) {
        var groupIds = [];
        trainMappings.forEach(function (mapping) {
            if (mapping.projectId == projectId) {
                groupIds.push(mapping.groupId);
            }

        });
        return groupIds;
    },

    getDepotColor: function () {
        return "#D6F6FF";
    },

    getPriorityColor: function (index) {
        if (index == -1) {
            return 'grey';
        } else if (index > 7 || index < 0) {
            return '';
        }
        // green, light blue, yellow, orange, red orange, red , black and purple
        var priorityColors = ["#00FF00", "#D6F6FF", "#FFFF00", "rgb(255, 180, 0)", "#FF3333", "red", "black", "#945ABF"];
        return priorityColors[index];
    },

    getSeverityColor: function (index) {
        if (index == -1) {
            return 'grey';
        } else if (index > 7 || index < 0) {
            return '';
        }
        // green, light blue, yellow, orange, red orange, red , black and purple
        var priorityColors = ["#00FF00", "#D6F6FF", "#F9EFE7", "#F9AB74", "#FA6901", "#FA6901", "black", "#945ABF"];
        return priorityColors[index];
    },

    getAlarmAckColor: function (level, issues) {
        if (level === -1) {
            return 'grey';
        } else if (level === 6) {
            return 'black';
        } else if (level > 7 || level < 0) {
            return '';
        }
        
        var index = 0;
        if(issues && issues.length > 0) {
            var allAlarmAcknowledged = issues.reduce(module.exports.checkIfAllAlarmAcknowledged, true);
            index = allAlarmAcknowledged ? 2 : 1;
        }
        // green, red, yellow
        var alarmAckStatusColors = ["lime", "red", "yellow"];
        return alarmAckStatusColors[index];
    },

    checkIfAllAlarmAcknowledged: function (allAcknowledged, currentIssue) {
        return allAcknowledged && currentIssue.acknowledged;
    }, 

    calculatePriorities: function (issues, tree) {
        tree.forEach(function (entry) {
            entry.priority = module.exports.getHighestPriority(issues, 'groupId', entry.groupId);
            entry.priorityColor = module.exports.getPriorityColor(entry.priority);
            entry.hosts.forEach(function (host) {
                host.priority = module.exports.getHighestPriority(issues, 'hostId', host.hostId);
                host.priorityColor = module.exports.getPriorityColor(host.priority);
            });

            entry.coaches.forEach(function (coach) {
                var priority = 0;
                coach.hosts.forEach(function (host) {
                    host.priority = module.exports.getHighestPriority(issues, 'hostId', host.hostId);
                    if (host.priority > priority) {
                        priority = host.priority;
                    }
                    host.priorityColor = module.exports.getPriorityColor(host.priority);
                });
                coach.priority = priority;
                coach.priorityColor = module.exports.getPriorityColor(coach.priority);
            });
        });

        issues.forEach(function (issue) {
            issue.priorityColor = module.exports.getPriorityColor(issue.priority);
        });
    },

    createCustomMarker: function (color, textColor, trainId) {
        var canvas, context;
        canvas = document.createElement("canvas");
        var dim = 84;
        canvas.width = dim;
        canvas.height = dim + 20;
        canvas.style.width = "32px";
        canvas.style.height = "42px";
        context = canvas.getContext("2d");
        var centerX = dim / 2;
        var centerY = dim / 2;
        var radius = dim / 2 - 2;
        var startAngle = 0.65 * Math.PI;
        var endAngle = 0.35 * Math.PI;
        context.arc(centerX, centerY, radius, startAngle, endAngle, false);
        context.fillStyle = 'white';
        context.fill();
        context.lineWidth = 1;
        context.strokeStyle = '#000';
        context.closePath();
        context.stroke();
        context.beginPath();
        context.arc(centerX, centerY, radius - 8, 0, 2 * Math.PI, false);
        context.fillStyle = color;
        context.fill();
        context.closePath();
        context.beginPath();
        context.beginPath();
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = "25px Arial";
        context.fillStyle = textColor;
        context.fillText(trainId, centerX, centerY);
        context.restore();
        context.save();

        var offset = 14;
        context.beginPath();
        context.moveTo(centerX - offset, radius * 2);
        context.lineTo(centerX, radius * 2 + 18);
        context.lineTo(centerX + offset, radius * 2);
        context.fillStyle = 'black';
        context.fill();
        context.lineWidth = 1;
        context.strokeStyle = 'black';
        context.closePath();
        context.stroke();

        context.restore();
        return canvas.toDataURL();
    },

    stripProjectAndTrain: function (hostname) {
        if (!util.isDefined(hostname)) {
            return "";
        }

        hostname = hostname.replace("MAR3-B", "CCU");

        var split = hostname.split("_");
        if (util.isDefined(split[2]) && !util.isDefined(split[3]))
            return split[2];
        if (!util.isDefined(split[2]) || !util.isDefined(split[3]))
            return hostname;
        var returnValue = split[2].replace("R", "C") + " " + split[3];
        return returnValue;
    },

    stripProject: function (trainname) {
        var split = trainname.split("_");
        if (!util.isDefined(split[1]))
            return trainname;
        var returnValue = split[1];
        return returnValue;
    },

    stripCoachFromHostname: function (hostname) {
        var split = hostname.split(" ");
        if (!util.isDefined(split[1]))
            return "";
        var returnValue = split[1];
        return returnValue;
    },

    stripDeviceFromHostname: function (hostname) {
        var split = hostname.split(" ");
        if (!util.isDefined(split[1]))
            return "";
        var returnValue = split[0];
        return returnValue;
    },

    getCoach: function (coachArray, coachName) {
        var foundCoach = undefined;
        coachArray.some(function (coach) {
            if (coach.name == coachName) {
                foundCoach = coach;
                return true;
            }
        });
        return foundCoach;
    },

    getHostByName: function (train, name) {
        var foundHost = undefined;

        train.hosts.some(function (host) {
            if (host.name == name) {
                foundHost = host;
                return true;
            }
        });

        train.coaches.some(function (coach) {
            coach.hosts.some(function (host) {
                if (host.name == name) {
                    foundHost = host;
                    return true;
                }
            });
            if (util.isDefined(foundHost)) {
                return true;
            }
        });
        return foundHost;
    },

    getCoachForHostId: function (train, hostId) {
        var foundCoach = undefined;

        train.coaches.some(function (coach) {
            coach.hosts.some(function (host) {
                if (host.hostId == hostId) {
                    foundCoach = coach;
                    return true;
                }
            });
            if (util.isDefined(foundCoach)) {
                return true;
            }
        });
        return foundCoach;
    },

    getCoachForName: function (train, name) {
        var foundCoach = undefined;

        train.coaches.some(function (coach) {
            if (coach.name == name) {
                foundCoach = coach;
                return true;
            }
        });
        return foundCoach;
    },

    getNewIssues: function (data, date) {
        var issues = new Array();
        data.forEach(function (entry) {
            if (entry.lastChanged.getTime() > date.getTime() && entry.lastChanged.getTime() <= new Date()) {
                issues.push(entry);
            }
        });
        return issues;
    },

    getTrainIds: function (data) {
        var ids = new Array();
        data.forEach(function (train) {
            ids.push(train.trainId);
        });
        return ids;
    },

    getTrain: function (data, trainId) {
        var foundTrain = undefined;
        data.some(function (train) {
            if (train.trainId == trainId) {
                foundTrain = train;
                return true;
            }
        });
        return foundTrain;
    },

    getHostInterfaceIP: function (ip) {
        var object = {};
        object.ip = ip;
        object.useip = 1;
        object.dns = "";
        object.main = 1;
        object.port = "10050";
        object.type = 1;

        return object;
    },

    getHostInterfaceSNMP: function (ip) {
        var object = {};
        object.ip = ip;
        object.useip = 1;
        object.dns = "";
        object.main = 1;
        object.port = "161";
        object.type = 2;
        return object;
    },

    getHostObject: function (host, proxyId, groupId, templateId, useIP, ip) {
        var interfaceObject;
        if (useIP) {
            interfaceObject = module.exports.getHostInterfaceIP(ip);
        } else {
            interfaceObject = module.exports.getHostInterfaceSNMP(ip);
        }

        return {
            'host': host,
            'proxyHostId': proxyId,
            'groups': [{'groupid': groupId}],
            'templates': [templateId],
            'interfaces': [interfaceObject]
        };
    },

    getDeviceByName: function (train, name) {
        var foundDevice;
        if (train && train.allDevices) {
            train.allDevices.some(function (device) {
                if (device.hostname == name) {
                    foundDevice = device;
                    return true;
                }
            });
        }
        return foundDevice;
    }
};

